<template>
  <b-container >
    <b-carousel
      id="carousel1"
      :interval="4000"
      v-model="slide"
      style="text-shadow: 1px 1px 2px #333;margin-bottom:5px;"
      controls
      indicators
      background="#ababab"
      img-width="1024"
      img-height="480"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <!-- Slides with custom text -->
      <b-carousel-slide
        :img-src="`${baseUrl}img/a1.png`"
        width="1024"
        height="480">
        <h3 >烟台市锐易电子技术有限公司</h3>
        <h3>以人为本，服务至上</h3>
      </b-carousel-slide>
      <!-- Text slides with image -->
      <!-- <b-carousel-slide
        :img-src="`${baseUrl}img/a2.png`"
        caption=""
        text="">
        <h1 >烟台市锐易电子技术有限公司</h1>
      </b-carousel-slide> -->

      <b-carousel-slide
        :img-src="`${baseUrl}img/a3.png`"
        caption=""
        text=""
        width="1024"
        height="480">
        <h3 >一切只为简约</h3>
      </b-carousel-slide>

    </b-carousel>

    <!-- </b-container> -->
</b-container></template>
<script>
export default {
  name: 'MyCarousel',
  data() {
    return {
      slide: 0,
      sliding: null,
      baseUrl: process.env.BASE_URL,
      // 使用环境变量中的全局变量
      baseApiUrl: process.env.VUE_APP_API_URL
    }
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    }
  }
}
</script>
